import React, { useEffect, useRef } from "react";
import * as bootstrap from "bootstrap";
import { useLanguageRes } from "../../services/Context/LanguageContext";

// Generic Continue/Cancel confirmation popup, driven by language-resource keys.
// `show` toggles the Bootstrap modal open/closed; the caller owns all decision logic
// in onContinue/onCancel (this component only renders and reports the click).
export default function ConfirmModal({
    show,
    messageKey,
    continueKey = "continue",
    cancelKey = "dascan",
    onContinue,
    onCancel,
}) {
    const { getLanguageContent } = useLanguageRes();
    const modalRef = useRef(null);

    useEffect(() => {
        if (!modalRef.current) return;

        if (show) {
            const modal = new bootstrap.Modal(modalRef.current, {
                backdrop: "static",
                keyboard: false,
            });
            modal.show();
        } else {
            const modal = bootstrap.Modal.getInstance(modalRef.current);
            if (modal) modal.hide();
        }
    }, [show]);

    return (
        // z-index above the page loader overlay (.dc-loader-overlay, 1060): this popup waits on the
        // patient's answer, so a loader still held elsewhere must never cover it and block the buttons.
        <div ref={modalRef} className="modal fade" tabIndex="-1" aria-hidden="true" style={{ zIndex: 1070 }}>
            <div className="modal-dialog modal-lg modal-dialog-top">
                <div className="modal-content">
                    <div className="modal-body py-4">
                        <p className="mb-0">{getLanguageContent(messageKey)}</p>
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="btn btn-outline-secondary" onClick={onCancel}>
                            {getLanguageContent(cancelKey)}
                        </button>
                        <button type="button" className="btn btn-primary" onClick={onContinue}>
                            {getLanguageContent(continueKey)}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
